// Daily Insight Engine - Chinese Calendar + Numerology + Biorhythm
// All calculations are purely algorithmic - no API, no backend needed

let Solar = null;
try {
  const lunarLib = require('lunar-javascript');
  Solar = lunarLib.Solar;
} catch (e) {
  console.log('lunar-javascript not available:', e.message);
}

// ===== HEAVENLY STEMS & EARTHLY BRANCHES =====
const HEAVENLY_STEMS = ['Jia (甲)', 'Yi (乙)', 'Bing (丙)', 'Ding (丁)', 'Wu (戊)', 'Ji (己)', 'Geng (庚)', 'Xin (辛)', 'Ren (壬)', 'Gui (癸)'];
const EARTHLY_BRANCHES = ['Zi (子)', 'Chou (丑)', 'Yin (寅)', 'Mao (卯)', 'Chen (辰)', 'Si (巳)', 'Wu (午)', 'Wei (未)', 'Shen (申)', 'You (酉)', 'Xu (戌)', 'Hai (亥)'];

const STEM_ELEMENTS = {
  '甲': 'Wood', '乙': 'Wood',
  '丙': 'Fire', '丁': 'Fire',
  '戊': 'Earth', '己': 'Earth',
  '庚': 'Metal', '辛': 'Metal',
  '壬': 'Water', '癸': 'Water',
};

const STEM_YIN_YANG = {
  '甲': 'Yang', '乙': 'Yin',
  '丙': 'Yang', '丁': 'Yin',
  '戊': 'Yang', '己': 'Yin',
  '庚': 'Yang', '辛': 'Yin',
  '壬': 'Yang', '癸': 'Yin',
};

const BRANCH_ANIMALS = {
  '子': 'Rat', '丑': 'Ox', '寅': 'Tiger', '卯': 'Rabbit',
  '辰': 'Dragon', '巳': 'Snake', '午': 'Horse', '未': 'Goat',
  '申': 'Monkey', '酉': 'Rooster', '戌': 'Dog', '亥': 'Pig',
};

const BRANCH_ELEMENTS = {
  '子': 'Water', '丑': 'Earth', '寅': 'Wood', '卯': 'Wood',
  '辰': 'Earth', '巳': 'Fire', '午': 'Fire', '未': 'Earth',
  '申': 'Metal', '酉': 'Metal', '戌': 'Earth', '亥': 'Water',
};

// ===== ELEMENT INTERACTIONS =====
const ELEMENT_GENERATES = { Wood: 'Fire', Fire: 'Earth', Earth: 'Metal', Metal: 'Water', Water: 'Wood' };
const ELEMENT_OVERCOMES = { Wood: 'Earth', Earth: 'Water', Water: 'Fire', Fire: 'Metal', Metal: 'Wood' };

// ===== CHINESE → ENGLISH TRANSLATIONS =====
const ACTIVITY_TRANSLATIONS = {
  '嫁娶': 'Marriage', '祭祀': 'Worship', '祈福': 'Prayer', '开光': 'Blessing',
  '出行': 'Travel', '交易': 'Trading', '签约': 'Contracts', '搬家': 'Moving',
  '入宅': 'Move In', '修造': 'Renovation', '动土': 'Groundbreaking', '安葬': 'Burial',
  '开业': 'Open Business', '纳采': 'Engagement', '出火': 'Light Fire', '拆卸': 'Demolition',
  '安门': 'Install Door', '栽种': 'Planting', '作灶': 'Build Stove', '针灸': 'Acupuncture',
  '求嗣': 'Seek Child', '纳畜': 'Buy Animals', '开市': 'Open Market', '立券': 'Sign Deed',
  '安床': 'Set Up Bed', '裁衣': 'Tailoring', '求医': 'See Doctor', '破土': 'Break Ground',
  '启钻': 'Open Tomb', '移柩': 'Move Coffin', '经络': 'Meridian', '解除': 'Cleansing',
  '沐浴': 'Bathing', '冠笄': 'Coming of Age', '会亲友': 'Visit Friends', '进人口': 'Adoption',
  '置产': 'Buy Property', '造船': 'Build Boat', '结网': 'Make Nets', '伐木': 'Logging',
  '畋猎': 'Hunting', '上梁': 'Raise Beam', '竖柱': 'Erect Pillar', '开仓': 'Open Storehouse',
  '造桥': 'Build Bridge', '治病': 'Healing', '赴任': 'Start Job', '领证': 'Get Certificate',
  '酝酿': 'Brew', '牧养': 'Herding', '理发': 'Haircut', '词讼': 'Litigation',
  '收养子女': 'Adopt Children', '纳财': 'Accept Wealth', '开渠': 'Dig Canal',
  '塞穴': 'Fill Holes', '补垣': 'Repair Walls', '扫舍': 'Clean House',
};

const DIRECTION_TRANSLATIONS = {
  '正东': 'East', '正西': 'West', '正南': 'South', '正北': 'North',
  '东南': 'Southeast', '东北': 'Northeast', '西南': 'Southwest', '西北': 'Northwest',
};

const translateActivity = (chinese) => ACTIVITY_TRANSLATIONS[chinese] || chinese;
const translateDirection = (chinese) => DIRECTION_TRANSLATIONS[chinese] || chinese;

// Nayin (纳音) translations - the "elemental sound" of each stem-branch pair
const NAYIN_TRANSLATIONS = {
  '海中金': 'Gold in the Sea', '炉中火': 'Fire in the Furnace', '大林木': 'Great Forest Wood',
  '路旁土': 'Roadside Earth', '剑锋金': 'Sword Edge Metal', '山头火': 'Mountaintop Fire',
  '涧下水': 'Water Under the Stream', '城头土': 'City Wall Earth', '白蜡金': 'White Wax Metal',
  '杨柳木': 'Willow Wood', '泉中水': 'Spring Water', '屋上土': 'Rooftop Earth',
  '霹雳火': 'Thunderbolt Fire', '松柏木': 'Pine & Cypress Wood', '长流水': 'Flowing River Water',
  '沙中金': 'Gold in the Sand', '山下火': 'Fire Under the Mountain', '平地木': 'Flatland Wood',
  '壁上土': 'Wall Earth', '金箔金': 'Gold Leaf Metal', '覆灯火': 'Covered Lamp Fire',
  '天河水': 'Celestial River Water', '大驿土': 'Highway Earth', '钗钏金': 'Hairpin Metal',
  '桑柘木': 'Mulberry Wood', '大溪水': 'Great Stream Water', '沙中土': 'Earth in the Sand',
  '天上火': 'Heavenly Fire', '石榴木': 'Pomegranate Wood', '大海水': 'Ocean Water',
};
const translateNaYin = (chinese) => NAYIN_TRANSLATIONS[chinese] || chinese;

// ===== 12 DAY OFFICERS (建除十二神) =====
const DAY_OFFICERS = {
  '建': { name: 'Establish', quality: 'auspicious', advice: 'Good for starting new projects, making plans, and setting intentions.' },
  '除': { name: 'Remove', quality: 'auspicious', advice: 'Good for clearing obstacles, cleaning, and removing negativity from your life.' },
  '满': { name: 'Full', quality: 'auspicious', advice: 'A day of abundance. Good for celebrations, receiving, and gratitude.' },
  '平': { name: 'Balance', quality: 'neutral', advice: 'A neutral day. Focus on maintaining equilibrium and routine tasks.' },
  '定': { name: 'Stable', quality: 'auspicious', advice: 'Good for making commitments, signing agreements, and solidifying plans.' },
  '执': { name: 'Hold', quality: 'neutral', advice: 'A day to hold your ground. Good for perseverance but avoid major changes.' },
  '破': { name: 'Break', quality: 'inauspicious', advice: 'A challenging day. Avoid starting new things. Good for breaking bad habits.' },
  '危': { name: 'Danger', quality: 'inauspicious', advice: 'Exercise caution today. Avoid risky decisions. Focus on safety and reflection.' },
  '成': { name: 'Success', quality: 'auspicious', advice: 'Excellent for completing tasks, achieving goals, and finalizing deals.' },
  '收': { name: 'Receive', quality: 'auspicious', advice: 'Good for collecting debts, receiving gifts, and gathering resources.' },
  '开': { name: 'Open', quality: 'auspicious', advice: 'Perfect for new beginnings, grand openings, and starting journeys.' },
  '闭': { name: 'Close', quality: 'inauspicious', advice: 'A day for rest and closure. Avoid new ventures. Good for meditation and endings.' },
};

// ===== PERSONAL DAY NUMEROLOGY =====
const PERSONAL_DAY_MEANINGS = {
  1: { theme: 'New Beginnings', energy: 'Leadership', advice: 'Take initiative today. Start something new. Trust your independence.', color: 'Red', focus: 'Self' },
  2: { theme: 'Partnership', energy: 'Cooperation', advice: 'Collaborate with others. Be patient and diplomatic. Listen more than you speak.', color: 'Orange', focus: 'Relationships' },
  3: { theme: 'Expression', energy: 'Creativity', advice: 'Express yourself freely. Social connections flourish. Let your creativity flow.', color: 'Yellow', focus: 'Communication' },
  4: { theme: 'Foundation', energy: 'Discipline', advice: 'Build something solid today. Focus on practical matters and organization.', color: 'Green', focus: 'Work' },
  5: { theme: 'Change', energy: 'Freedom', advice: 'Embrace the unexpected. Adventure awaits. Stay adaptable and open-minded.', color: 'Blue', focus: 'Adventure' },
  6: { theme: 'Harmony', energy: 'Nurturing', advice: 'Focus on home and family. Take care of responsibilities with love.', color: 'Indigo', focus: 'Home & Family' },
  7: { theme: 'Reflection', energy: 'Wisdom', advice: 'Go inward today. Seek knowledge and spiritual insight. Trust your intuition.', color: 'Violet', focus: 'Spirituality' },
  8: { theme: 'Abundance', energy: 'Power', advice: 'Take charge of your finances and career. Manifest your goals with confidence.', color: 'Gold', focus: 'Prosperity' },
  9: { theme: 'Completion', energy: 'Compassion', advice: 'Let go of what no longer serves you. Be generous and humanitarian.', color: 'Silver', focus: 'Release & Give' },
  11: { theme: 'Illumination', energy: 'Inspiration', advice: 'A master number day. Pay attention to signs and synchronicities. Inspire others.', color: 'White', focus: 'Higher Purpose' },
  22: { theme: 'Master Builder', energy: 'Manifestation', advice: 'A powerful day for building your dreams into reality. Think big, act practical.', color: 'Platinum', focus: 'Grand Vision' },
  33: { theme: 'Master Teacher', energy: 'Healing', advice: 'Share your wisdom. Uplift others through compassion and understanding.', color: 'Rose Gold', focus: 'Healing Others' },
};

// ===== ELEMENT DAILY ADVICE =====
const ELEMENT_ADVICE = {
  Wood: { icon: '🌳', quality: 'Growth & Creativity', advice: 'A day favoring growth, new ideas, and creative pursuits. Be flexible like bamboo.' },
  Fire: { icon: '🔥', quality: 'Passion & Action', advice: 'High energy day. Take action with passion but avoid burnout. Shine brightly.' },
  Earth: { icon: '🌍', quality: 'Stability & Nourishment', advice: 'Ground yourself today. Focus on stability, nourishment, and steady progress.' },
  Metal: { icon: '⚔️', quality: 'Precision & Clarity', advice: 'Cut through confusion with clarity. Good for decisions and refined thinking.' },
  Water: { icon: '💧', quality: 'Wisdom & Flow', advice: 'Go with the flow today. Trust your intuition and let wisdom guide you.' },
};

// ===== BIORHYTHM CALCULATION =====
const calculateBiorhythm = (birthDate, targetDate) => {
  const birth = new Date(birthDate);
  const target = new Date(targetDate);
  birth.setHours(0, 0, 0, 0);
  target.setHours(0, 0, 0, 0);
  
  const daysAlive = Math.floor((target - birth) / (1000 * 60 * 60 * 24));
  
  const physical = Math.sin((2 * Math.PI * daysAlive) / 23);
  const emotional = Math.sin((2 * Math.PI * daysAlive) / 28);
  const intellectual = Math.sin((2 * Math.PI * daysAlive) / 33);
  
  const getPhase = (value) => {
    if (Math.abs(value) < 0.05) return 'critical';
    if (value > 0.7) return 'peak';
    if (value > 0.3) return 'high';
    if (value > 0) return 'rising';
    if (value > -0.3) return 'falling';
    if (value > -0.7) return 'low';
    return 'trough';
  };

  const getAdvice = (p, e, i) => {
    const pPhase = getPhase(p);
    const ePhase = getPhase(e);
    const iPhase = getPhase(i);
    
    if (pPhase === 'critical' || ePhase === 'critical' || iPhase === 'critical') {
      return 'Transition day — be extra mindful and avoid major decisions.';
    }
    if (p > 0.5 && e > 0.5 && i > 0.5) {
      return 'All cycles are high — an excellent day for challenges!';
    }
    if (p < -0.5 && e < -0.5 && i < -0.5) {
      return 'All cycles are low — rest, recharge, and be gentle with yourself.';
    }
    if (p > 0.5 && e < 0) {
      return 'Physical energy is high but emotions are low — channel energy into exercise.';
    }
    if (e > 0.5 && p < 0) {
      return 'Emotional clarity is strong — great for relationships and creative work.';
    }
    if (i > 0.5 && p < 0 && e < 0) {
      return 'Mental sharpness is your strength today — study, analyze, and plan.';
    }
    if (p > 0 && e > 0 && i < 0) {
      return 'Body and heart are aligned — trust your feelings over overthinking.';
    }
    return 'Mixed energies — balance activity with rest and go with your instincts.';
  };

  return {
    daysAlive,
    physical: Math.round(physical * 100),
    emotional: Math.round(emotional * 100),
    intellectual: Math.round(intellectual * 100),
    physicalPhase: getPhase(physical),
    emotionalPhase: getPhase(emotional),
    intellectualPhase: getPhase(intellectual),
    advice: getAdvice(physical, emotional, intellectual),
  };
};

// ===== PERSONAL DAY NUMBER CALCULATION =====
const reduceToSingleDigit = (num) => {
  // Keep master numbers 11, 22, 33
  if (num === 11 || num === 22 || num === 33) return num;
  while (num > 9) {
    num = String(num).split('').reduce((sum, d) => sum + parseInt(d), 0);
    if (num === 11 || num === 22 || num === 33) return num;
  }
  return num;
};

const calculatePersonalDay = (birthMonth, birthDay, targetDate) => {
  const target = new Date(targetDate);
  const currentYear = target.getFullYear();
  const currentMonth = target.getMonth() + 1;
  const currentDay = target.getDate();
  
  const bm = parseInt(birthMonth);
  const bd = parseInt(birthDay);
  
  // Personal Year = reduce(birth_month + birth_day + current_year_digits)
  const yearDigitSum = String(currentYear).split('').reduce((sum, d) => sum + parseInt(d), 0);
  const personalYear = reduceToSingleDigit(bm + bd + yearDigitSum);
  
  // Personal Month = reduce(Personal Year + current_month)
  const personalMonth = reduceToSingleDigit(personalYear + currentMonth);
  
  // Personal Day = reduce(Personal Month + current_day)
  const personalDay = reduceToSingleDigit(personalMonth + currentDay);
  
  return {
    personalYear,
    personalMonth,
    personalDay,
    meaning: PERSONAL_DAY_MEANINGS[personalDay] || PERSONAL_DAY_MEANINGS[personalDay % 9 || 9],
  };
};

// ===== ELEMENT COMPATIBILITY =====
const getElementRelationship = (birthElement, dayElement) => {
  if (birthElement === dayElement) {
    return { type: 'Same', description: 'Your element matches today\'s energy — amplified power and harmony.', quality: 'harmonious' };
  }
  if (ELEMENT_GENERATES[birthElement] === dayElement) {
    return { type: 'You Generate', description: `Your ${birthElement} feeds today's ${dayElement} — you give energy outward. Good for helping others.`, quality: 'giving' };
  }
  if (ELEMENT_GENERATES[dayElement] === birthElement) {
    return { type: 'Supported', description: `Today's ${dayElement} nourishes your ${birthElement} — the universe supports you today.`, quality: 'supported' };
  }
  if (ELEMENT_OVERCOMES[birthElement] === dayElement) {
    return { type: 'You Control', description: `Your ${birthElement} controls today's ${dayElement} — you have the upper hand. Assert yourself.`, quality: 'empowered' };
  }
  if (ELEMENT_OVERCOMES[dayElement] === birthElement) {
    return { type: 'Challenged', description: `Today's ${dayElement} challenges your ${birthElement} — stay mindful and don't overextend.`, quality: 'challenging' };
  }
  return { type: 'Neutral', description: 'Neutral energy between your element and today. Balance is key.', quality: 'neutral' };
};

// ===== PERSONAL BAZI DAILY TRANSIT =====
const STEM_ROMANIZATION = {
  '甲': 'Jia', '乙': 'Yi', '丙': 'Bing', '丁': 'Ding', '戊': 'Wu',
  '己': 'Ji', '庚': 'Geng', '辛': 'Xin', '壬': 'Ren', '癸': 'Gui',
};

const TEN_GOD_MEANINGS = {
  '比肩': {
    name: 'Independent Momentum',
    traditionalName: 'Companion',
    theme: 'Self-direction, confidence, and personal initiative',
    description: 'Today mirrors your core energy, emphasizing independence and confidence in your own approach.',
    bestUse: 'Advance one personal priority and make a decision you have been postponing.',
    watchFor: 'Stubbornness or refusing useful support.',
  },
  '劫财': {
    name: 'Shared Momentum',
    traditionalName: 'Peer Challenge',
    theme: 'Collaboration, competition, and boundaries',
    description: 'Peer energy is active today, making cooperation powerful while also testing boundaries and priorities.',
    bestUse: 'Collaborate where goals align and be explicit about responsibilities.',
    watchFor: 'Comparison, impulsive commitments, or giving away too much time.',
  },
  '食神': {
    name: 'Creative Flow',
    traditionalName: 'Eating God',
    theme: 'Creativity, enjoyment, and productive expression',
    description: 'Your energy flows naturally into ideas, communication, and work that feels personally meaningful.',
    bestUse: 'Create, teach, cook, write, or turn an idea into something tangible.',
    watchFor: 'Comfort becoming procrastination.',
  },
  '伤官': {
    name: 'Bold Expression',
    traditionalName: 'Hurting Officer',
    theme: 'Originality, candor, and questioning conventions',
    description: 'Original ideas and direct expression are emphasized, helping you see where old methods can improve.',
    bestUse: 'Create, explain, or challenge an outdated approach constructively.',
    watchFor: 'Blunt words, impatience with rules, or reacting before reviewing.',
  },
  '偏财': {
    name: 'Flexible Opportunity',
    traditionalName: 'Indirect Wealth',
    theme: 'Networking, adaptability, and unexpected opportunities',
    description: 'A flexible, outward-looking energy favors noticing openings that routine thinking might miss.',
    bestUse: 'Follow up with people, explore options, and act on a practical opportunity.',
    watchFor: 'Overpromising, scattered attention, or unnecessary spending.',
  },
  '正财': {
    name: 'Steady Resources',
    traditionalName: 'Direct Wealth',
    theme: 'Consistency, practical value, and responsible management',
    description: 'Steady effort and careful use of time or resources are more valuable than dramatic action today.',
    bestUse: 'Organize finances, complete practical work, and honor existing commitments.',
    watchFor: 'Rigidity or measuring every decision only by immediate results.',
  },
  '七杀': {
    name: 'Courage Under Pressure',
    traditionalName: 'Seven Killings',
    theme: 'Decisiveness, challenge, and disciplined courage',
    description: 'Pressure can sharpen your focus today when it is met with preparation rather than impulse.',
    bestUse: 'Handle the hardest important task directly and set a firm boundary.',
    watchFor: 'Risk-taking, conflict, or treating urgency as an emergency.',
  },
  '正官': {
    name: 'Structure & Responsibility',
    traditionalName: 'Direct Officer',
    theme: 'Discipline, commitments, and principled leadership',
    description: 'Structure and responsibility are highlighted, rewarding a measured and dependable approach.',
    bestUse: 'Follow through, clarify standards, and lead by example.',
    watchFor: 'Perfectionism or becoming overly concerned with approval.',
  },
  '偏印': {
    name: 'Unconventional Insight',
    traditionalName: 'Indirect Resource',
    theme: 'Intuition, experimentation, and alternative learning',
    description: 'Unusual connections may be easier to notice today, especially when you step outside familiar methods.',
    bestUse: 'Research, experiment, and give a quiet insight room to develop.',
    watchFor: 'Overthinking, isolation, or abandoning practical details.',
  },
  '正印': {
    name: 'Support & Learning',
    traditionalName: 'Direct Resource',
    theme: 'Preparation, guidance, recovery, and knowledge',
    description: 'Supportive energy favors learning, thoughtful preparation, and restoring what has been depleted.',
    bestUse: 'Study, seek trusted guidance, document knowledge, or make time to recover.',
    watchFor: 'Waiting for perfect certainty before acting.',
  },
};

const BRANCH_COMBINATIONS = {
  '子': '丑', '丑': '子', '寅': '亥', '亥': '寅', '卯': '戌', '戌': '卯',
  '辰': '酉', '酉': '辰', '巳': '申', '申': '巳', '午': '未', '未': '午',
};

const BRANCH_CLASHES = {
  '子': '午', '午': '子', '丑': '未', '未': '丑', '寅': '申', '申': '寅',
  '卯': '酉', '酉': '卯', '辰': '戌', '戌': '辰', '巳': '亥', '亥': '巳',
};

const PILLAR_AREAS = {
  Day: 'close relationships and personal commitments',
  Month: 'work, routines, and your immediate environment',
  Year: 'your social environment and broader connections',
};

const getDailyArchetype = (birthDayStem, dayStem) => {
  let tenGodKey = '';
  try {
    const { LunarUtil } = require('lunar-javascript');
    tenGodKey = LunarUtil.SHI_SHEN[birthDayStem + dayStem] || '';
  } catch (e) {
    tenGodKey = '';
  }

  const meaning = TEN_GOD_MEANINGS[tenGodKey] || {
    name: 'Personal Element Focus',
    traditionalName: 'Daily Relationship',
    theme: 'Balance and intentional action',
    description: 'Today invites you to balance your natural energy with the character of the day.',
    bestUse: 'Choose one meaningful priority and approach it intentionally.',
    watchFor: 'Spreading your attention too thinly.',
  };

  return {
    key: tenGodKey,
    chinese: tenGodKey,
    ...meaning,
  };
};

const getBranchInteractions = (dayBranch, birthPillars) => birthPillars
  .map((pillar) => {
    let type = null;
    if (BRANCH_COMBINATIONS[dayBranch] === pillar.branch) type = 'Combination';
    else if (BRANCH_CLASHES[dayBranch] === pillar.branch) type = 'Clash';
    if (!type) return null;

    const area = PILLAR_AREAS[pillar.label];
    const todayAnimal = BRANCH_ANIMALS[dayBranch];
    const natalAnimal = BRANCH_ANIMALS[pillar.branch];
    const isCombination = type === 'Combination';

    return {
      type,
      quality: isCombination ? 'supported' : 'challenging',
      natalPillar: pillar.label,
      natalBranch: pillar.branch,
      natalAnimal,
      todayBranch: dayBranch,
      todayAnimal,
      area,
      title: `${pillar.label} Branch ${type}`,
      summary: `Today's ${todayAnimal} ${isCombination ? 'combines with' : 'clashes with'} your natal ${natalAnimal} ${pillar.label.toLowerCase()} branch.`,
      description: isCombination
        ? `This traditionally emphasizes cooperation and integration around ${area}.`
        : `This traditionally suggests movement or competing demands around ${area}; flexibility is more useful than force.`,
    };
  })
  .filter(Boolean);

// ===== MAIN DAILY INSIGHT FUNCTION =====
// targetDate is optional so the exact same engine powers the live card and future notifications.
export const getDailyInsight = (birthMonth, birthDay, birthYear, targetDate = new Date()) => {
  if (!Solar) {
    throw new Error('lunar-javascript library not loaded');
  }

  const requestedDate = targetDate instanceof Date ? new Date(targetDate.getTime()) : new Date(targetDate);
  if (Number.isNaN(requestedDate.getTime())) {
    throw new Error('Invalid target date');
  }

  const year = requestedDate.getFullYear();
  const month = requestedDate.getMonth() + 1;
  const day = requestedDate.getDate();
  const today = new Date(year, month - 1, day, 12, 0, 0, 0);

  const solar = Solar.fromYmd(year, month, day);
  const lunar = solar.getLunar();
  const lunarMonthNum = lunar.getMonth();
  const lunarDayNum = lunar.getDay();

  const by = parseInt(birthYear);
  const bm = parseInt(birthMonth);
  const bd = parseInt(birthDay);
  const birthSolar = Solar.fromYmd(by, bm, bd);
  const birthLunar = birthSolar.getLunar();
  const birthEightChar = birthLunar.getEightChar();

  const dayGanZhi = lunar.getDayInGanZhi();
  const dayStem = dayGanZhi.charAt(0);
  const dayBranch = dayGanZhi.charAt(1);

  const birthYearGanZhi = birthEightChar.getYear();
  const birthMonthGanZhi = birthEightChar.getMonth();
  const birthDayGanZhi = birthEightChar.getDay();
  const birthDayStem = birthEightChar.getDayGan();
  const birthDayBranch = birthEightChar.getDayZhi();

  const dayElement = STEM_ELEMENTS[dayStem] || 'Earth';
  const birthElement = STEM_ELEMENTS[birthDayStem] || 'Earth';
  const dayYinYang = STEM_YIN_YANG[dayStem] || 'Yang';
  const birthYinYang = STEM_YIN_YANG[birthDayStem] || 'Yang';
  const dayAnimal = BRANCH_ANIMALS[dayBranch] || 'Dragon';

  const dailyArchetype = getDailyArchetype(birthDayStem, dayStem);
  const branchInteractions = getBranchInteractions(dayBranch, [
    { label: 'Day', branch: birthDayBranch },
    { label: 'Month', branch: birthEightChar.getMonthZhi() },
    { label: 'Year', branch: birthEightChar.getYearZhi() },
  ]);

  const dayOfficerChinese = lunar.getZhiXing();
  const dayOfficer = DAY_OFFICERS[dayOfficerChinese] || { name: 'Balance', quality: 'neutral', advice: 'A balanced day for all activities.' };

  let dayYi = [];
  let dayJi = [];
  try {
    dayYi = (lunar.getDayYi() || []).map(translateActivity);
    dayJi = (lunar.getDayJi() || []).map(translateActivity);
  } catch (e) {
    // Some dates may not have this data.
  }

  let luckyDirections = {};
  try {
    luckyDirections = {
      wealth: translateDirection(lunar.getDayPositionCaiDesc()),
      happiness: translateDirection(lunar.getDayPositionXiDesc()),
      fortune: translateDirection(lunar.getDayPositionFuDesc()),
    };
  } catch (e) {
    luckyDirections = { wealth: 'East', happiness: 'South', fortune: 'North' };
  }

  let dayNaYin = '';
  try {
    dayNaYin = translateNaYin(lunar.getDayNaYin());
  } catch (e) {
    dayNaYin = '';
  }

  const personalDay = calculatePersonalDay(birthMonth, birthDay, today);
  const birthDate = new Date(by, bm - 1, bd, 12, 0, 0, 0);
  const biorhythm = calculateBiorhythm(birthDate, today);
  const elementRelationship = getElementRelationship(birthElement, dayElement);
  const clashAnimal = lunar.getDayChongDesc ? lunar.getDayChongDesc() : '';

  const ANIMAL_TRANSLATIONS = { '鼠': 'Rat', '牛': 'Ox', '虎': 'Tiger', '兔': 'Rabbit', '龙': 'Dragon', '蛇': 'Snake', '马': 'Horse', '羊': 'Goat', '猴': 'Monkey', '鸡': 'Rooster', '狗': 'Dog', '猪': 'Pig' };
  const birthYearAnimal = birthLunar.getYearShengXiao();
  const birthAnimalTranslated = ANIMAL_TRANSLATIONS[birthYearAnimal] || birthYearAnimal;

  let clashAnimalName = clashAnimal;
  try {
    const clashMatch = clashAnimal.match(/[)）](.+)$/);
    if (clashMatch) {
      clashAnimalName = ANIMAL_TRANSLATIONS[clashMatch[1]] || clashMatch[1];
    }
  } catch (e) {
    // Keep the untranslated value if the library returns an unexpected format.
  }

  const pad = (value) => String(value).padStart(2, '0');

  return {
    date: {
      year,
      month,
      day,
      iso: `${year}-${pad(month)}-${pad(day)}`,
      formatted: today.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' }),
    },
    lunarDate: { month: lunarMonthNum, day: lunarDayNum, monthChinese: lunar.getMonthInChinese(), dayChinese: lunar.getDayInChinese() },
    dayPillar: {
      ganZhi: dayGanZhi,
      stem: dayStem,
      branch: dayBranch,
      element: dayElement,
      yinYang: dayYinYang,
      animal: dayAnimal,
      naYin: dayNaYin,
    },
    birthPillar: {
      ganZhi: birthDayGanZhi,
      year: birthYearGanZhi,
      month: birthMonthGanZhi,
      day: birthDayGanZhi,
      element: birthElement,
      yearAnimal: birthAnimalTranslated,
      dayMaster: {
        stem: birthDayStem,
        name: STEM_ROMANIZATION[birthDayStem] || birthDayStem,
        display: `${STEM_ROMANIZATION[birthDayStem] || birthDayStem} (${birthDayStem})`,
        element: birthElement,
        yinYang: birthYinYang,
      },
    },
    dailyArchetype,
    branchInteractions,
    dayOfficer: {
      chinese: dayOfficerChinese,
      ...dayOfficer,
    },
    elementAdvice: ELEMENT_ADVICE[dayElement],
    elementRelationship,
    activities: {
      auspicious: dayYi.slice(0, 6),
      inauspicious: dayJi.slice(0, 6),
    },
    luckyDirections,
    personalDay,
    biorhythm,
    clash: clashAnimalName,
  };
};

// ===== EXPORT FOR EXTERNAL USE =====
export { calculateBiorhythm, calculatePersonalDay, getElementRelationship };
